import LogoS from '../../../assets/images/logo-s.png'
import './index.scss'

const Logo = () => {

  return (
    <div className="logo-container solid-logo">
      <img src={LogoS}/>
    </div>
  )
}

export default Logo
